import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { authenticateRequest, logoutRequest, setCredentialFlowStep } from "../../../store/modules/auth/actions";

import Loading from "../../../components/Loading";
import RecaptchaInvisible from "../../../components/Recaptcha/RecaptchaInvisible";
import history from "../../../services/history";
import { STEP } from "../../../shared/constants";

export default function PrepareLogin() {
	const dispatch = useDispatch();

	const { dataPrepareLogin } = useSelector((state) => state.auth);

	const [tokenReCaptcha, setTokenReCaptcha] = useState(null);
	const [reCaptchaError, setReCaptchaError] = useState(false);

	useEffect(() => {
		const fluxPromo = JSON.parse(localStorage.getItem("FLUX_PROMO"));
		const navigation = window.history.state;

		if (fluxPromo && fluxPromo.isPromo && fluxPromo.keyNavigation === navigation.key) {
			dispatch(setCredentialFlowStep(STEP.LOGIN));
			history.push(fluxPromo.route);
		}

		if (fluxPromo && !fluxPromo.keyNavigation) {
			const data = {
				...fluxPromo,
				keyNavigation: window.history.state ? window.history.state.key : null,
			};
			localStorage.setItem("FLUX_PROMO", JSON.stringify(data));
		}
	}, []);

	useEffect(() => {
		const timeout = setTimeout(() => {
			if (!Boolean(dataPrepareLogin)) {
				handleLogout();
			}

			if (dataPrepareLogin && tokenReCaptcha) {
				handleLogout();
				toast.error(
					"Não foi possível fazer o login, verifique os dados e tente novamente!"
				);
			}
		}, 5000);

		return () => clearTimeout(timeout);
	}, [dataPrepareLogin]);

	useEffect(() => {
		if (reCaptchaError) {
			handleLogout();
		}
	}, [reCaptchaError]);

	const authenticate = (token) => {
		setTokenReCaptcha(token);

		if (!dataPrepareLogin) return handleLogout("Forçando logout na tentativa de login");

		const { cpf, password, isProAuth, options, toMarket, adid } = dataPrepareLogin;

		dispatch(authenticateRequest(cpf, password, isProAuth, options, toMarket, token, adid));
	};

	function handleLogout(reason = "Logout após tentativa de login") {
		dispatch(logoutRequest(reason));
	}

	return (
		<div>
			<Loading newLoading={true} />
			{dataPrepareLogin && (
				<RecaptchaInvisible
					change={() => {}}
					token={authenticate}
					error={setReCaptchaError}
				/>
			)}
		</div>
	);
}
